<template>
  <Empty v-bind="getBindValue" />
</template>

<script setup lang="ts">
  import { Empty, EmptyProps } from 'ant-design-vue';
  import { computed, useAttrs } from 'vue';
  import { EMPTY_IMG } from '@mts/assets/empty';
  import { t } from '@mts/hooks/web/useI18n';

  defineOptions({
    name: 'BaseEmpty',
    inheritAttrs: false,
  });

  const props = withDefaults(defineProps<EmptyProps>(), {});

  const attrs = useAttrs();
  const getBindValue = computed(() => {
    const { image, description, ...restProps } = props;

    return {
      ...attrs,
      ...restProps,
      image: typeof image === 'string' ? EMPTY_IMG[image] || image : image || EMPTY_IMG.DEFAULT,
      description: typeof description === 'string' ? t(description) : description,
    } as EmptyProps;
  });
</script>
